import React from "react"
import { Link } from "gatsby"
import { CardSubtitle, CardTitle, Card, CardBody } from "reactstrap"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
export default function SocialIcons() {
  return (
    <div>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      ></link>
      <Card className="text-center mb-0">
        <CardBody>
          <CardTitle>Follow Us on Social Media</CardTitle>
          <CardSubtitle>
            <Link
              to="https://facebook.com/freelancology"
              className="fa fa-facebook"
              onClick={e => {
                e.preventDefault()
                trackCustomEvent({
                  category: "Special Campaign Button",
                  action: "Click",
                  label: "Facebook Page Link Open",
                  value: 1,
                })
              }}
            ></Link>
            <Link
              to="https://twitter.com/freelancology"
              className="fa fa-twitter"
              onClick={e => {
                e.preventDefault()
                trackCustomEvent({
                  category: "Special Campaign Button",
                  action: "Click",
                  label: "Twitter Page Link Open",
                  value: 1,
                })
              }}
            ></Link>
            <Link
              to="https://instagram.com/freelancology"
              className="fa fa-instagram"
              onClick={e => {
                e.preventDefault()
                trackCustomEvent({
                  category: "Special Campaign Button",
                  action: "Click",
                  label: "Instagram Page Link Open",
                  value: 1,
                })
              }}
            ></Link>
            <Link
              to="https://linkedin.com/company/freelancology"
              className="fa fa-linkedin"
              onClick={e => {
                e.preventDefault()
                trackCustomEvent({
                  category: "Special Campaign Button",
                  action: "Click",
                  label: "LinkedIn Page Link Open",
                  value: 1,
                })
              }}
            ></Link>
            <Link
              to="https://youtube.com/freelancology"
              className="fa fa-youtube"
              onClick={e => {
                e.preventDefault()
                trackCustomEvent({
                  category: "Special Campaign Button",
                  action: "Click",
                  label: "Youtube Page Link Open",
                  value: 1,
                })
              }}
            ></Link>
          </CardSubtitle>
        </CardBody>
      </Card>
    </div>
  )
}
